import { determineValidChars } from '../utils';
export function serializeVariableFn(schema) {
  const chars = determineValidChars(schema);
  return function (state, node) {
    let value;
    if (node.marks.mapBy('type').includes(schema.marks.strong) && chars.strong) {
      value = `${chars.strong.first}${chars.strong.second}${node.attrs.type}${chars.strong.last}`;
    } else {
      value = `${chars.normal.first}${chars.normal.second}${node.attrs.type}${chars.normal.last}`;
    }
    state.write(value);
    state.renderInline(node);
  };
}